/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export enum ContentType {
  "image/jpeg" = "image/jpeg",
  "image/png" = "image/png",
  "application/pdf" = "application/pdf",
  "application/msword" = "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document" = "application/msword",
  "application/vnd.ms-excel" = "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" = "application/vnd.ms-excel",
  "application/zip" = "application/zip",
}
